import { useFlippers } from "@shared/context/FlippersContext";

const useTitanExplicitTosFlipper = (): boolean => {
  const [isTitanExplicitTosEnabled] = useFlippers("titan_explicit_tos");

  return isTitanExplicitTosEnabled;
};

export { useTitanExplicitTosFlipper };
